import { z } from 'zod';
/**
 * Honeypot field (Fase A6) — ONE name, shared by every side that touches it.
 *
 * WHY IT LIVES IN ITS OWN MODULE (review #491 MINOR-4). The name stood written
 * out three times: in the widget, in the edge gate and in each schema. The
 * measured consequence: rename it on the widget side only and BOTH suites stay
 * green while the honeypot is dead in production. Now the schemas and the edge
 * import this constant, and the widget (which must not pull zod into a browser
 * bundle) mirrors it under a test that compares the two.
 *
 * The name is deliberately mundane — a company field a scraper expects to see,
 * which is why it is not called `honeypot`. That same mundanity is what makes
 * a browser want to autofill it, so the widget marks the input
 * `autocomplete="new-password"`: Chromium maps that onto no address field.
 */
export const HONEYPOT_FIELD_NAME = 'firma';
/**
 * ACCEPTED by the schema on purpose — a 400 would tell the bot which field
 * gave it away. The edge answers a filled honeypot with the same 200 a real
 * submit gets and forwards nothing; the backend never sees the key. Bounded so
 * it can never be used as a payload.
 */
export const honeypotFieldSchema = z.string().max(200).optional();
